// this style is in modal dialog directly under <body>, out of the feature scope, so use as the global pattern
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export const uetTagManageDialogStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '.manage-tag-alert.in': {

    '& .modal-dialog': {

      '& .modal-content': {
        width: 550,
        boxShadow: '-2px 0 8px rgba(0, 0, 0, 0.15)',
        top: 'calc(50% - 90px)',
        left: 'calc(50% - 275px)',
        flex: '0 0 auto',
        display: 'flex',
        position: 'fixed',
        flexDirection: 'column',

        '& .modal-header': {
          display: 'block',
          padding: 24,

          '& .close': {
            marginTop: 8,
          },

          '& .dialog-close-button': {
            fontFamily: iconFontFamily,
            fontSize: '16px',
            content: '"\\E711"',
            float: 'right',
            display: 'inline-block',
          },
          '& .dialog-close-button:before': {
            content: '"\\E711"',
          },
        },

        '& .modal-body': {
          padding: '0px 24px',
        },

        '& .modal-footer': {
          padding: 24,
          border: 'none',
        },
      },
    },
  },
  '.modal-backdrop.in': {
    zIndex: 'auto',
    backgroundColor: palette.white,
  },
});
